// Is a single matrix cell filled in acceptably for its column type?
//
// A 'number' column must actually hold a number. The analysis layer duck-types
// matrix answers with Number(raw) — a non-numeric value there would silently
// turn the whole column categorical, so it is rejected at entry.
const isValidCellValue = (value, columnType) => {
    const v = String(value ?? "").trim();
    if (v.length === 0) return false;

    if (columnType === "number") return !Number.isNaN(Number(v));

    return true;
};

export default isValidCellValue;
